module.exports = __webpack_public_path__ + "static/media/bocconi-logo-neg@3x.48f0e12e.png";